export default "__VITE_PUBLIC_ASSET__87be42df__"